{
  "title": "Library",
  "featured_exercises": "Favorites",
  "exercise_library": "Exercises",
  "add_featured_placeholder": "Your favorites will appear here",
  "no_exercises_found": "No exercises found.",
  "error_toggle_favorite": "Failed to update favorite status",
  "error_forbidden_account_sync": "Access forbidden. Please ensure your account is fully synced."
}
